import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "5",
      d: "M50 75.416c17.673 0 32-14.328 32-32.001 0-17.674-14.327-32-32-32s-32.001 14.326-32.001 32c0 17.673 14.327 32 32 32Z"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "50",
      cy: "66.5",
      fill: "currentColor",
      rx: "6",
      ry: "1.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M33.648 82.244a10 10 0 0 1-1.76 1.519l-.39.263-.432.187c-.377.163-.738.496-.934 1.025-.41 1.106.187 2.176.974 2.489 5.18 2.058 11.765 3.272 18.895 3.272s13.714-1.214 18.895-3.272c.786-.313 1.383-1.383.973-2.489-.196-.53-.556-.863-.934-1.026l-.432-.186-.39-.264a10 10 0 0 1-1.76-1.518 40.5 40.5 0 0 1-16.352 3.431 40.5 40.5 0 0 1-16.353-3.43"
    }, null, -1)
  ])))
}
export default { render: render }